import { MessageService } from 'primeng/api';
import { Subject, Subscription } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

import { DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ProgressService } from 'src/app/services/progress.service';
import { Race } from 'src/app/models/race';
import { RaceClass } from 'src/app/models/race-class';
import { Lap, Mark, RaceProgress, RaceRefreshObject } from 'src/app/models';
import { SettingsService } from 'src/app/services/settings.service';

@Component({
  selector: 'app-progress-list',
  templateUrl: './progress-list.component.html',
  styleUrls: ['./progress-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressListComponent implements OnInit, OnDestroy {
  @Input() selectedRace!: Race;
  @Input() raceClasses: RaceClass[] = [];
  @Input() selectedLang!: string;
  @Input() TVResume!: boolean;
  @Input() sections: number = 1;
  @Input() timer = 1000;
  _selectedClass!: RaceClass;
  loading!: boolean;
  subscriptionGet!: Subscription;
  col_width: number = 70;
  lastDateUpdate!: Date;
  raceProgress: RaceProgress | null = null;
  minimize = false;
  @Input() set selectedClass(value: RaceClass) {
    this._selectedClass = value;
    this.getInitiator.next(this._selectedClass.clUid);
  }
  get selectedClass(): RaceClass {
    return this._selectedClass;
  }

  @Output() refreshEvent: EventEmitter<RaceRefreshObject> = new EventEmitter();
  @Output() openInfoEvent: EventEmitter<string> = new EventEmitter();
  @Output() goToNewVersion: EventEmitter<void> = new EventEmitter();
  @ViewChildren('section', { read: ElementRef }) rowElement!: QueryList<ElementRef>;

  scrollableCols: any[];
  getDNF: string[];
  lapHover: Lap | null;
  time_state = 1;
  modeEdit = false;
  checkHeight = false;

  private getInitiator: Subject<RaceClass['clUid']> = new Subject();

  constructor(
    public progressService: ProgressService,
    public appSettings: SettingsService,
    private datePipe: DatePipe,
    private ref: ChangeDetectorRef,
    private route: ActivatedRoute,
    public messageService: MessageService
  ) {
    this.progressService.refreshTableData.subscribe(() => {
      this.getInitiator.next(this.selectedClass.clUid);
    });

    this.lapHover = null;

    this.scrollableCols = [];

    this.getDNF = ['', 'дисквалификация', 'вышло время', 'поломка', 'травма', 'не финишировал'];

    this.route.queryParams.subscribe((params) => {
      const state = params['state'];
      if (state) {
        this.time_state = Number(state);
      }

      const col_width = params['col_width'];
      if (col_width) {
        this.col_width = col_width;
      } else {
        this.col_width = 70;
      }
    });

    this.subscribeToGet();
  }

  ngOnDestroy(): void {
    this.subscriptionGet.unsubscribe();
    this.progressService.refreshTableData.unsubscribe();
  }

  clickInfo(cUid: string) {
    this.openInfoEvent.emit(cUid);
  }

  refreshGet() {
    this.getInitiator.next(this.selectedClass.clUid);
  }

  private subscribeToGet() {
    this.subscriptionGet = this.getInitiator
      .pipe(
        tap(() => {
          this.loading = true;
        }),
        switchMap((classUid) => {
          return this.progressService.getRaceProgress(this.selectedRace.rUid, classUid);
        }),
        tap(() => {
          this.loading = false;
          this.ref.detectChanges();
        })
      )
      .subscribe((raceProgress: RaceProgress) => {
        let maxLaps = 1;
        if (!raceProgress) {
          return;
        }

        // TODO имя круга??
        // const lapsNames: string[] = [];
        raceProgress.classes.forEach((classObj) => {
          classObj.registrations.forEach((compObj) => {
            // if (!lapsNames.length) {
            //   compObj.laps.forEach((lap) => {
            //     lapsNames.push(lap.name);
            //   });
            // }
            if (compObj.laps.length > maxLaps) {
              maxLaps = compObj.laps.length;
            }
          });
        });

        this.scrollableCols = [];
        for (let i = 0; i < maxLaps; i++) {
          this.scrollableCols.push({
            field: `lap`,
            lap: i,
            // TODO откуда брать имя круга?
            // header: lapsNames[i],
            header: i,
            type: 1,
            width: this.TVResume ? `${this.col_width}px` : '110px',
          });
        }

        this.raceProgress = raceProgress;
        this.checkHeight = true;
        this.ref.detectChanges();

        this.lastDateUpdate = new Date();
      });
  }

  ngOnInit() {

    if (this.TVResume) {
      let i = 0;
      setInterval(() => {
        if (!this.rowElement) {
          return;
        }
        console.log(`scroll to ${i}`);
        const el = this.rowElement.find((r) => {
          return r.nativeElement.getAttribute('id') === `section_${i}`;
        });
        if (el) {
          el.nativeElement.scrollIntoView({
            behavior: 'smooth',
            inline: 'start',
            block: 'start',
          });
        }
        i = i + 1;
        if (i > this.sections) {
          i = 0;
        }
      }, this.timer * 2);
    }

    console.log(`%c ------ ПАРАМЕТРЫ QUERY ПАРАМЕТРОВ ------ `, 'background: #222; color: #bada55');
    console.log(
      `
    %ctimer%c - Время обновления страницы, по умолчанию 5000\r\n
    %cclUid%c - код класса\r\n
    %csections%c - кол-во секция для разбития. По умолчанию 1. Валидные значения 1, 2, 3, 4, 6, 12\r\n
    %cstate%c - состояние отображения таймеров. По умолчанию 1.
      1 - отметки
      2 - от предыдущей отметки
      3 - от начала круга
      4 - от старта участника
      5 - отставания от лидера\r\n
    %ccol_width%c - ширина колонок. По умолчанию 70px
    `,
      'background: #222; color: green',
      'color: lightgray',
      'background: #222; color: green',
      'color: lightgray',
      'background: #222; color: green',
      'color: lightgray',
      'background: #222; color: green',
      'color: lightgray',
      'background: #222; color: green',
      'color: lightgray'
    );
    const dateString = this.datePipe.transform(this.selectedRace.date, 'dd/MM/yyyy');
    this.raceClasses.forEach((raceClass) => {
      console.log(
        `${raceClass.name} - https://marshalone.ru/progress/list?date=${dateString}&section=results-table&uid=${this.selectedRace.rUid}&lang=ru&clUid=${raceClass.clUid}&state=2&sections=2`
      );
    });
    console.log(`%c ---------------------------------------- `, 'background: #222; color: #bada55');
  }

  newVersion() {
    this.goToNewVersion.emit();
  }

  timeStateChange(state: number) {
    this.time_state = state;
    this.checkHeight = true;
    this.ref.markForCheck();
  }

  erase(mark: Mark) {
    mark.time = null;
  }

  trash(mark: Mark) {
    mark.delete = true;
  }

  refresh(selectClass: RaceClass) {
    this.refreshEvent.emit({
      selectedRace: this.selectedRace,
      raceClasses: this.raceClasses,
      selectedClassUid: selectClass.clUid,
    });
  }

  hoverLap(lap: Lap) {
    if (this.lapHover !== lap) {
      this.lapHover = lap;
    } else {
      this.lapHover = null;
    }
  }

  setDateMark(mark: Mark, event: { value: Date }) {
    if (!event.value) {
      return;
    }
    if (!mark.time) {
      mark.time = new Date(this.selectedRace.date);
    }
    mark.time.setFullYear(event.value.getFullYear());
    mark.time.setMonth(event.value.getMonth());
    mark.time.setDate(event.value.getDate());
  }

  setTimeMark(mark: Mark, event) {
    if (!event.value) {
      return;
    }
    if (!mark.time) {
      mark.time = new Date(this.selectedRace.date);
    }
    mark.time.setHours(event.value.getHours());
    mark.time.setMinutes(event.value.getMinutes());
    mark.time.setSeconds(event.value.getSeconds());
  }
}
